var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"pt-10 pb-32 bg-gray-800"},[_c('div',{staticClass:"max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"},[_c('h1',{staticClass:"text-3xl leading-9 font-bold text-white capitalize"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }